import { React, useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { DotLoading, AutoCenter } from 'antd-mobile';
import CarList from 'pages/mobile/car/CarList';
import CarInfo from 'pages/mobile/car/CarInfo';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import secureStorage from '../../shared/secureStorage';

const CarRouter = () => {
  const [carList, setCarList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const webviewHttpHandler = new WebviewHttpHandler(true);
  const lineUserId = secureStorage.getItem('lineUserId');

  // 檢核使用者是否有租約
  const checkRichmenu = () => {
    webviewHttpHandler.post(`/richmenu_mgmt/richmenu_switch`, {
      user_id: lineUserId,
    });
  };

  // 打API取得全部車輛列表
  const getCarList = () => {
    setIsLoading(true);
    webviewHttpHandler
      .get(`/service/member/car?line=${lineUserId}`)
      .then((response) => {
        setCarList(response.data);
        // 如果只有一台車, 則直接跳轉到車輛資訊頁面
        if (response.data.length === 1) {
          secureStorage.setItem('oneCarRedirect', 'true');
          const car = response.data[0];
          navigate(`/m/car/CarInfo`, {
            state: {
              plateNumber: car.car,
              color: car.color,
              brand: car.brand,
              model: car.category,
              year: car.year,
              displacement: car.displacement,
              isAllowMt: car.is_allow_mt,
              isAllowInsp: car.is_allow_insp,
              isShowInsp: car.is_show_insp,
            },
          });
        } else if (response.data.length === 0) {
          window.location.href =
            'https://lt.hotaileasing.com.tw/location.htm';
        } else {
          secureStorage.setItem('oneCarRedirect', 'false');
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    checkRichmenu();
    getCarList();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="main-container">
          <AutoCenter>
            載入中
            <DotLoading />
          </AutoCenter>
        </div>
      ) : (
        <Routes>
          <Route
            path="/CarList"
            element={<CarList carList={carList} />}></Route>
          <Route path="/CarInfo/*" element={<CarInfo />}></Route>
        </Routes>
      )}
    </>
  );
};

export default CarRouter;
